//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React, { useState } from 'react';
import styled from 'styled-components';

import { DefaultIconButton } from '@components/atoms/button/Button';
import { SectionText } from '@components/atoms/text/Text';
import Cuid from '@models/Cuid';
import IItemMetadata from '@models/IItemMetadata';
import ReelId from '@models/ReelId';
import { EditorDisabledNotes } from '@uia/products/EditorDisabledNotes';
import { WorkflowTooltips } from '@uia/products/WorkflowTooltips';
import { ProductTagsList } from '@uia/products/product-tags/ProductTagsList';
import { isDefined } from '@utils/filterPredicates';

export interface ProductsContainerProps {
  cuid: Cuid;
  metadata: IItemMetadata;
}

export const ProductsContainer = ({
  cuid,
  metadata,
}: ProductsContainerProps) => {
  const [isEditorEnabled, setIsEditorEnabled] = useState(false);
  const [hasValidProductItems, setHasValidProductItems] = useState(false);
  const [numProductsWithMissingInfo, setNumProductsWithMissingInfo] =
    useState(0);

  return (
    <Container>
      <SectionText>
        Add Products
        {hasValidProductItems && (
          <DefaultIconButton
            aria-label='Close'
            iconName='close'
            onClick={() => {
              setHasValidProductItems(false);
              setIsEditorEnabled(false);
            }}
          />
        )}
      </SectionText>
      {
        // TODO: PD-262197 - Migrate universal-image-actions-productize-sku-limits
      }
      <WorkflowTooltips />
      {!isEditorEnabled && (
        <EditorDisabledNotes
          hasValidProductItems={hasValidProductItems}
          isProductTaggingSupported={metadata.disableProductTagging}
          numProductsWithMissingInfo={numProductsWithMissingInfo}
          reelId={
            isDefined(metadata.reelId) ? ReelId(metadata.reelId) : undefined
          }
        />
      )}
      <ProductTagsList
        isCatalogConnected={false} // TODO: PD-263795 UIA Products, React Port, Product tags mutations
        isDisabled={!isEditorEnabled}
        onEditProductTag={() => ({
          // TODO: PD-263795 UIA Products, React Port, Product tags mutations
        })}
        onRemoveProductTag={() => ({
          // TODO: PD-263795 UIA Products, React Port, Product tags mutations
        })}
        productTags={metadata.productTags}
      />
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[3]};
    padding: ${theme.spacings[3]};
  `,
);
